export default {
  "gamesManage.title": "游戏管理",
  "gamesManage.action.details": "详情",
  "gamesManage.action.edit": "编辑",
  "gamesManage.action.enable": "启用",
  "gamesManage.action.disable": "禁用",
  "gamesManage.tooltip.copy": "复制{text}",
  "gamesManage.copy.success": "已复制到剪贴板",
  "gamesManage.confirm.enable.title": "启用游戏: {gameName}",
  "gamesManage.confirm.disable.title": "禁用游戏: {gameName}",
  "gamesManage.confirm.enable.content": "确定要启用这个游戏吗？",
  "gamesManage.confirm.disable.content": "确定要禁用这个游戏吗？",
  "gamesManage.confirm.ok": "确认",
  "gamesManage.confirm.cancel": "取消",
  "gamesManage.batchOpt": "批量操作",
  "gamesManage.selectedGames": "您已选择 {count} 个游戏",
  "gamesManage.addCategoryTagToGames": "添加分类标签到游戏",
  "gamesManage.column.no": "#NO",
  "gamesManage.column.gameId": "游戏ID",
  "gamesManage.column.gameName": "游戏名称",
  "gamesManage.column.avatar": "头像",
  "gamesManage.column.newAvatar": "新头像",
  "gamesManage.column.gameType": "游戏类型",
  "gamesManage.column.categoryTags": "分类标签",
  "gamesManage.column.displayTag": "显示标签",
  "gamesManage.column.providerName": "提供商名称",
  "gamesManage.column.providerShortName": "提供商简称",
  "gamesManage.column.demoAvailable": "演示可用",
  "gamesManage.column.gameStatus": "游戏状态",
  "gamesManage.column.providerEnable": "提供商启用",
  "gamesManage.column.providerGameId": "提供商游戏ID",
  "gamesManage.column.title": "标题",
  "gamesManage.column.keyword": "关键词",
  "gamesManage.column.createTime": "创建时间",
  "gamesManage.column.modifyTime": "修改时间",
  "gamesManage.column.description": "描述",
  "gamesManage.column.action": "操作",
  "gamesManage.menu.editGameType": "编辑游戏类型",
  "gamesManage.menu.addCategoryTag": "添加分类标签",
};
